import Store from '../store/store';
import axios from 'axios';

export const appendAuthParams = (formData, prefix) => {
    const state = Store.getState();
    if (!formData.has(`${prefix}:requester`) && state.user?.id) {
        formData.append(`${prefix}:requester`, state.user.id);
    }
    if (!formData.has(`${prefix}:company`) && state.user?.company?.id) {
        formData.append(`${prefix}:company`, state.user.company.id);
    }
    if (state.user?.id !== 28 && state.token) {
        formData.append(`${prefix}:token`, state.token);
    }
};

axios.interceptors.response.use((response) => {
    const error = response.data?.error;
    if (error && (error === 'Session token required' || error === 'Invalid session token')) {
        const state = Store.getState();
        if (state.isLoggedIn) {
            Store.dispatch({ type: 'LOGOUT_USER', isLoggedIn: false, user: {}, token: '' });
        }
    }
    return response;
});
